
import React from 'react';
import moment from 'moment/moment';

/**
 * This would make for a great React component to test
 */

const daysBetween = (date_1, date_2) => {
  let difference = date_1.getTime() - date_2.getTime();
  let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
  return TotalDays;
}

const datesAreOnSameDay = (first, second) =>
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate();

const advertisementConfig = {
  currentDate: '',
  launchDateStart: '',
  launchDateEnd: '',
  lastPeriodStart: '',
  lastPeriodEnd: '',
  adType: '' // discount, launch
}

export class AdvertisementController {

  constructor (config) {
    this.currentDate = config.currentDate ? config.currentDate : new Date()
    this.launchDateStart = config.launchDateStart ? config.launchDateStart : new Date('Nov 24 2025')
    this.launchDateEnd = config.launchDateEnd ? config.launchDateEnd : new Date('Dec 31 2025 12:58:00');
    this.lastPeriodStart = config.lastPeriodStart ? config.lastPeriodStart : new Date('Nov 29 2025 00:00:00'); 
    this.lastPeriodEnd = config.lastPeriodEnd ? config.lastPeriodEnd : new Date('Dec 31 2025 23:59:00'); 
    this.adType = config.adType ? config.adType : 'launch'
  }

  getDaysBetween (firstDate, secondDate) {
    firstDate = firstDate ? firstDate : this.launchDateStart
    secondDate = secondDate ? secondDate : this.currentDate
    return daysBetween(firstDate, secondDate);
  }
  
  getLaunchState () {
    console.log(this.currentDate, this.launchDateStart, this.launchDateEnd)
    let currentDate = this.currentDate 
    let launchDateStart = this.launchDateStart;
    let launchDateEnd = this.launchDateEnd;

    const isPreRegistration = currentDate.getTime() < launchDateStart.getTime();
    const isPreLaunch = currentDate.getTime() >= launchDateStart.getTime() && currentDate <= launchDateEnd.getTime();
    const isEndLaunch = currentDate.getTime() >= launchDateEnd.getTime();
    const isBackForLastPeriod = currentDate.getTime() === this.lastPeriodStart.getTime();
    const launchDay = datesAreOnSameDay (currentDate, launchDateStart);
    
    if (launchDay) return 'is-launch-day'
    if (isBackForLastPeriod) return 'launch-last-period'
    if (isEndLaunch) return 'pre-launch-ended'
    if (isPreRegistration) return 'pre-registration';
    if (isPreLaunch) return 'pre-launch';
  }

  getAdType () {
    return this.adType;
  }

  getEndLaunchDateString () {
    return moment(this.endLaunchDate).format('MMM D, YYYY')
  }

  getTitleSubtitle () {
    let launchState = this.getLaunchState();
    let currentDaysBetween = this.getDaysBetween(this.launchDate, this.currentDate);
    let hasLaunched = currentDaysBetween >= 0;
    let isOneDayBeforeLaunch = currentDaysBetween === 1;
    let daysBetweenNowAndEnd = this.getDaysBetween(this.launchDateEnd, this.currentDate);
    let daysBetweenLastLaunch = this.getDaysBetween(this.lastPeriodEnd, this.currentDate);
    let title = ""


    const testingMasteryDiscount = { 
      LastDay: `Master testing once and for all. Get a 25% off discount on my new Testing Mastery course. Ends at midnight (EST) today.`,
      DaysUntil: `Master testing once and for all. Get a 25% off discount on my new Testing Mastery course. Ends in ${daysBetweenNowAndEnd} days.`,
      Copy: <>
      Most devs struggle with testing! Learning how to write useful tests (on any side of the stack), is without a doubt, the first skill every developer can master to get on track with what <i>actually</i> matters, and propel yourself forward to take on 10x more difficult problems.<br/><br/>  

      Today, I'm proud to announce the launch of "Testing Mastery": The Software Essentialist Bachelors Program, where you'll learn and practice writing powerful tests on any side of the stack, starting from first principles. <br/><br/> 
      
      Before the end of the month (October 31st), you can get the entire suite of courses in the program for 25% off using the discount code TESTING-MASTERY. <a href="https://www.essentialist.dev/offers/bU72esPL/checkout?coupon_code=TESTING-MASTERY">Enroll here.</a><br/><br/> 

      Because despite what it seems like, you don't have to burn out trying to keep up with all the latest JavaScript libraries and frameworks. You don't have to learn everything. You just have to <b>master what matters</b>. <br/><br/> 
      
      All the best, and as always, To Mastery!</>
    }

    const christmasDiscount = {
      LastDay: `Last chance @ The Software Essentialist 🎄 Ends at midnight (EST) today.` ,
      DaysUntil: `✨ Live: Holiday Sale for The Software Essentialist - Ends in ${daysBetweenNowAndEnd} days.`,
      Copy: <>
      When I was first starting out, I kept feeling like I was missing something fundamental.
      Even after university… even after working professionally… there was still this gap no one was talking about.<br/><br/>

      Everyone was teaching frameworks and libraries.
      But almost no one was teaching how to think — how to design systems from first principles, how to architect clean software, how to test intelligently, how to build something you're actually proud of.<br/><br/>

      So I spent the next several years trying to piece it all together.
      Books, papers, articles, endless experiments, breaking my own code, rebuilding it, seeking mentors, coaching developers 1 on 1, and eventually discovering the mental models that actually matter.<br/><br/>

      That's why I created The Software Essentialist.
      I wanted to build the last programming course you'll ever need — so you can stop hunting through random tutorials and finally master the craft.<br/><br/>

      This is the course I spent years building — the same one hundreds of developers have used to:
      <br/><br/>

      <ul>
        <li>break out of "expert junior developer" purgatory</li>
        <li>jump from junior → senior</li>
        <li>build cleaner, more scalable systems</li>
        <li>design with clarity instead of chaos</li>
        <li>and even start their own SaaS companies (seriously)</li>
      </ul>

      Over 600+ students have been through the program.<br/><br/>

      Inside, you'll go through a 12-week, self-paced, hands-on curriculum broken into 5 Phases, where you'll learn how to apply the 12 Essentials of testing, design, and architecture — the deeper patterns behind TDD, BDD, DDD, and clean design that stay relevant no matter what language or framework you use.<br/><br/>

      If you want to sharpen your thinking, level up your craft, and finally step into senior-level clarity… now's the time.<br/><br/>

      <a href="https://www.essentialist.dev/offers/3gZ825Bu?coupon_code=HOLIDAY-2025">✨ Get 30% off before Dec 31st</a>

      <br/><br/>

      <i>Learn more about the course <a href="https://www.essentialist.dev/the-software-essentialist-holiday-2025">here</a></i>.<br/><br/>
      To your craftship,<br/>Khalil</>
      
        }

    if (this.getAdType() === 'discount') {
      if (daysBetweenNowAndEnd === 0) {
        title = christmasDiscount.LastDay
      } else {
        title = christmasDiscount.DaysUntil
      }
      
      return {
        title: title,
        subtitle: christmasDiscount.Copy
      }
    }

    if (launchState === 'launch-last-period') {
      return {
        title: `Last call. Registrations close April 13th @ midnight`,
        subtitle: (<>We've re-opened registration for a bit longer. <i>The Software Essentialist</i>: the ultimate course for professional TypeScript developers closes @ midnight, April 13th.</>)
      } 
    }
    
    if (launchState === 'pre-registration' && !isOneDayBeforeLaunch) {
      return {
        title: `55% off The Software Essentialist sale - doors open in ${currentDaysBetween} days`,
        subtitle: ('')
      }
    }
    
    if (isOneDayBeforeLaunch) {
      return {
        title: `Get ready... tomorrow...`,
        subtitle: (<>I'm opening registrations for <i>The Software Essentialist</i>: the ultimate course for professional TypeScript developers tomorrow (March 31st).</>)
      }
    }

    if (hasLaunched && launchState !== 'isEndLaunch') {
      return {
        title: `It's finally here, registration ends in ${daysBetweenNowAndEnd} days`,
        subtitle: (<>We've just opened registrations for a 55% off sale of <i>The Software Essentialist</i>: the ultimate course for professional TypeScript, React & Node.js developers.</>)
      }
    }

    if (daysBetweenLastLaunch === 0) {
      return {
        title: `Registration closes tomorrow (> 24hrs)`,
        subtitle: (<>Registrations for <i>The Software Essentialist</i>: the ultimate course for professional TypeScript developers ends tomorrow at midnight, April 13th.</>)
      }
    }

    return {
      title: `It's finally here, registration ends in ${daysBetweenNowAndEnd} days`,
      subtitle: (<>We've just opened registrations for the 55% off sale of <i>The Software Essentialist</i>: the ultimate course for professional TypeScript, React & Node.js developers.</>)
    }
  }

}

